<script>
const { VUE_APP_API_HOST } = process.env

export default {
  methods: {

    findDraft(botId, newsId,) {
      return this.$http
        .get(`${VUE_APP_API_HOST}/drafts/find?botId=${botId}&newsId=${newsId}&timezone=${-new Date().getTimezoneOffset()}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    newDraft(draft) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/drafts/`, draft, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    updateDraft(draft) {
      return this.$http
        .put(`${VUE_APP_API_HOST}/drafts/${draft.id}`, draft, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    deleteDraft(id, page=null) {
      return this.$http
        .delete(`${VUE_APP_API_HOST}/drafts/${id}${page ? `?page=${page.id}` : ''}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    getDrafts(page) {
      return this.$http.get(`${VUE_APP_API_HOST}/drafts?${Array.isArray(page) ? `pages=${JSON.stringify(page)}` : `page=${page}`}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then(
        (res) => res.body.drafts || [],
        (err) => err
      )
    }
  }
}
</script>
